import React, { useContext } from 'react';

import { Button, Flex, Spin } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

import { SubscriptionContext } from '@/App';
import { totalAvailableReports } from '@/layouts/subscription/helper';
import { ReactComponent as SubsApproval } from '@/layouts/subscription/src/SubsApproval.svg';
import { ReactComponent as PaymentFail } from '@/layouts/subscription/src/payment-fail.svg';
import { useSubscription } from '@/layouts/subscription/useSubscription';

export const CopilotCompletion: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const { refetch, subscriptionLoading } = useContext(SubscriptionContext);
	const [redirectStatus, setRedirectStatus] = React.useState<boolean>(false);
	const { refetch: refetchSubscriptions } = useSubscription();

	React.useEffect(() => {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		const status = params.get('redirect_status');
		// setRedirectStatus(true);
		setRedirectStatus(status === 'succeeded' ? true : false);
		console.log('status', status);
		if (status === 'succeeded') {
			refetch();
			// refetchSubscriptions(); return old subs in this place
		}
		url.search = ''; // Remove all query parameters
		// navigate(url.pathname + url.hash, { replace: true }); // Replace current entry in the history stack
	}, []);

	const onClick = () => {
		redirectStatus
			? navigate('/app/dashboard/video-insights-co-pilot')
			: navigate('/app/copilot-subscriptions');
	};
	return (
		<Spin spinning={subscriptionLoading}>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '80vh',
					width: '100%',
					flexDirection: 'column',
				}}
				className="subscription-wrapper"
			>
				<div>
					{redirectStatus ? (
						<SubsApproval
							style={{
								width: '400px',
								transform: 'scale(1)',
							}}
						/>
					) : (
						<PaymentFail
							style={{
								width: '400px',
								transform: 'scale(1)',
							}}
						/>
					)}
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						maxWidth: '500px',
						alignItems: 'center',
					}}
				>
					<h1 style={{ textAlign: 'center' }}>
						{redirectStatus ? (
							<Flex vertical gap={16} align="center">
								<span>Your subscription is now active!</span>
								<span style={{ fontWeight: 400, fontSize: '20px' }}>
									To start analyzing videos, open Video Insights Co-Pilot
									extension and sign in with your account.
								</span>
							</Flex>
						) : (
							'Looks like something went wrong. You might want to try again.'
						)}
					</h1>

					<Button
						type="primary"
						onClick={onClick}
						size="large"
						style={{ width: 'fit-content' }}
					>
						{redirectStatus
							? 'Back to dashboard'
							: 'Back to subscription plans'}
					</Button>
				</div>
			</div>
		</Spin>
	);
};
